import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

// PrimeNG spike theme — Aura preset retinted to PlanaCan's cultivation green so
// p-table (and any other PrimeNG components) match the refreshed look & feel.
export const PlanacanPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50:  '#eafaf0',
      100: '#d2f4de',
      200: '#a9e8bf',
      300: '#74d699',
      400: '#41c177',
      500: '#2f9e54',
      600: '#258a47',
      700: '#1d6f39',
      800: '#155a2d',
      900: '#124b27',
      950: '#052e16',
    },
  },
});
